export default __webpack_public_path__ + "static/media/RAIDER 125_2.71818e31.webp";